import { render } from "./RetornoAssinatura.vue?vue&type=template&id=001a60f0"
import script from "./RetornoAssinatura.vue?vue&type=script&lang=js"
export * from "./RetornoAssinatura.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__